import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Concatenate class names with Tailwind-aware conflict resolution.
 *
 * Used by all shadcn-derived components — keeps overrides predictable when
 * variants and consumer classes intersect (e.g. `bg-primary` vs `bg-card`).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Format a millisecond duration as a compact human label (e.g. "1.2s", "320ms"). */
export function formatLatency(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return '—';
  if (ms < 1000) return `${Math.round(ms)}ms`;
  return `${(ms / 1000).toFixed(1)}s`;
}

/** Clamp a number to a [min, max] range. */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}
